<template lang="html">
  <div class="services">
    <div v-for="s in services" class="service">
      {{s.name}} ({{s.price}}€)</b>
      <label><input type="checkbox" class="ios-switch" @change="setPrice(s.id, $event)"/><div><div></div></div></label>
      <!-- <input type="checkbox" @change="setPrice(s.id, $event)"> -->
    </div>
  </div>
</template>

<script>
import {services} from '../../assets/configuration.js'

export default {
  data () {
    return {
      services,
      prices: [
        {id: 0, selected: 0},
        {id: 1, selected: 0},
        {id: 2, selected: 0},
        {id: 3, selected: 0},
        {id: 4, selected: 0},
        {id: 5, selected: 0},
        {id: 6, selected: 0},
        {id: 7, selected: 0}
      ]
    }
  },
  methods: {
    setPrice (id, e) {
      var p = parseInt(this.services[id].price)
      if (e.target.checked) {
        this.prices[id].selected = 1
        this.$store.commit('addPrice', p)
      } else {
        this.prices[id].selected = 0
        this.$store.commit('subPrice', p)
      }
      this.setDevis()
    },
    setDevis () {
      this.$store.commit('setDevis', {id: 5, set: {services: this.prices}})
    }
  }
}
</script>

<style lang="css" scoped>
.services {
  color: #FFF;
  font-weight: bold;
  position: relative;
}
.service {
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  align-items: center;
}
input {
  flex-shrink: 1;
  width: auto;
  height: 28px;
}

input[type="checkbox"] {
	position: absolute;
	opacity: 0;
}
input[type="checkbox"].ios-switch + div {
  top: 8px;
  position: relative;
	vertical-align: middle;
	width: 40px;	height: 20px;
	border: 1px solid #f3f3f3;
	border-radius: 999px;
	background-color: #f3f3f3;
	-webkit-transition-duration: .4s;
	-webkit-transition-property: background-color, box-shadow;
	box-shadow: inset 0 0 0 0px rgba(0,0,0,0.4);
	margin: 0;
  margin-bottom: 20px;
  cursor: pointer;
}

/* Checked Track (Blue) */
input[type="checkbox"].ios-switch:checked + div {
	width: 40px;
	background-position: 0 0;
	background-color: #1e4f92;
	border: 1px solid #ff0000;
	box-shadow: inset 0 0 0 10px #ff0000;
}
/* Normal Knob */
input[type="checkbox"].ios-switch + div > div {
	float: left;
	width: 18px; height: 18px;
	border-radius: inherit;
	background: #ffffff;
	-webkit-transition-timing-function: cubic-bezier(.54,1.85,.5,1);
	-webkit-transition-duration: 0.4s;
	-webkit-transition-property: transform, background-color, box-shadow;
	-moz-transition-timing-function: cubic-bezier(.54,1.85,.5,1);
	-moz-transition-duration: 0.4s;
	-moz-transition-property: transform, background-color;
	box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3), 0px 0px 0 1px rgba(0, 0, 0, 0.4);
	pointer-events: none;
	margin-top: 1px;
	margin-left: 1px;
}

/* Checked Knob (Blue Style) */
input[type="checkbox"].ios-switch:checked + div > div {
	-webkit-transform: translate3d(20px, 0, 0);
	-moz-transform: translate3d(20px, 0, 0);
	background-color: #ffffff;
	box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3), 0px 0px 0 1px rgba(8, 80, 172,1);
}

</style>



// WEBPACK FOOTER //
// Services.vue?ac107144